import { render, staticRenderFns } from "./CreateChecklist.vue?vue&type=template&id=4cb98503&"
import script from "./CreateChecklist.vue?vue&type=script&lang=ts&"
export * from "./CreateChecklist.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports